<template>
    <l-map
        ref="formMap"
        style="height: 300px"
        :zoom="map.zoom"
        :center="map.center"
        :options="map.options"
        :crs="map.crs"
    >
        <!-- Boutons zoom -->
        <l-control-zoom position="topright"></l-control-zoom>

        <!-- Couche OSM -->
        <l-tile-layer :url="map.url"></l-tile-layer>

        <!-- Affichage de l'objet si le zoom est suffisant -->
        <l-geo-json :geojson="geojson" />
    </l-map>
</template>

<script>
import { LMap, LControlZoom, LTileLayer, LGeoJson } from 'vue2-leaflet';
import { geoJSON, CRS } from 'leaflet';
// import featureGroup désactivé

// Valeurs par défaut centrées sur la France - La carte est ensuite recentrée sur l'emprise spécifiée en admin.
// Montpellier // const MAP_CENTER = [43.61092, 3.87723];
const MAP_CENTER = [46, 2];
const ZOOM = 6;

export default {
    props: {
        value: Object,
    },
    data() {
        return {
            map: {
                zoom: ZOOM,
                center: MAP_CENTER,
                bounds: null,
                crs: CRS.EPSG3857,
                options: {
                    zoomControl: false,
                },
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            },
            geojson: null,
        };
    },
    watch: {
        value: function(newVal) {
            this.value = newVal;
            if (this.value && this.value.type) {
                this.loadGeom(this.value);
            }
        },
    },
    computed: {},
    mounted() {
        if (this.value && this.value.type) {
            this.loadGeom(this.value);
        }
    },
    methods: {
        /**
         * Affiche la géométrie et centre dessus
         */
        loadGeom: function(geom) {
            this.geojson = geom;
            const bounds = geoJSON(this.geojson).getBounds();
            this.$refs.formMap.mapObject.fitBounds(bounds);
        },
    },
    components: {
        LMap,
        LControlZoom,
        LTileLayer,
        LGeoJson,
    },
};
</script>

<style lang="scss"></style>
